/* Miphoria select-options popup ("UpsellPopup").
   Opened by any element with class "upsell-add-btn" carrying the data attributes
   from snippets/upsell-data-attrs.liquid. Markup lives in layout/theme.liquid. */
(function () {
  if (window.upsellPopup) return;

  const isColour = (name) => /^colou?r$/i.test(String(name || '').trim());
  const parse = (json, fallback) => {
    try {
      return JSON.parse(json || '');
    } catch (e) {
      return fallback;
    }
  };
  const money = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency, maximumFractionDigits: 0 }).format(Number(cents) / 100);
  };
  // Compare image URLs regardless of width/version params
  const imageKey = (src) => String(src || '').split('?')[0].replace(/^https?:/, '');

  class UpsellPopup {
    constructor(root) {
      this.root = root;
      this.panel = root.querySelector('.upsell-popup__content');
      this.mainImage = root.querySelector('.upsell-popup__main-img');
      this.thumbs = root.querySelector('.upsell-popup__thumbs');
      this.eyebrow = root.querySelector('.upsell-popup__collection');
      this.title = root.querySelector('.upsell-popup__title');
      this.price = root.querySelector('.upsell-popup__price');
      this.options = root.querySelector('.upsell-popup__options');
      this.addBtn = root.querySelector('.upsell-popup__add');
      this.addLabel = root.querySelector('.upsell-popup__add-label');
      this.details = root.querySelector('.upsell-popup__details');
      this.error = root.querySelector('.upsell-popup__error');
      this.cache = {};
      this.isOpen = false;

      root.addEventListener('click', (e) => {
        if (e.target.closest('[data-upsell-close]') || !e.target.closest('.upsell-popup__content')) this.close();
      });
      root.addEventListener('submit', (e) => e.preventDefault());
      this.addBtn.addEventListener('click', () => this.addToCart());
      document.addEventListener('keydown', (e) => {
        if (this.isOpen && e.key === 'Escape') this.close();
      });
      window.addEventListener('popstate', () => {
        if (this.isOpen) this.close({ fromHistory: true });
      });
    }

    open(button) {
      this.trigger = button;
      const d = button.dataset;
      this.variants = parse(d.variants, []);
      this.optionsData = parse(d.options, []);
      this.selected = parse(d.variantOptions, []) || [];
      this.images = parse(d.images, []).map((img) => (typeof img === 'string' ? { src: img, alt: '' } : img));
      if (!this.images.length && d.image) this.images = [{ src: d.image, alt: '' }];
      this.colourIndex = this.optionsData.findIndex((o) => isColour(o.name));
      this.swatchesHtml = d.swatches || '';

      this.eyebrow.textContent = d.collection || '';
      this.eyebrow.hidden = !d.collection;
      this.title.textContent = d.title || '';
      this.details.href = d.url || '#';

      // Fill in missing selections with the first available variant's values
      const fallback = this.variants.find((v) => v.available) || this.variants[0];
      this.optionsData.forEach((o, i) => {
        if (!this.selected[i] && fallback) this.selected[i] = fallback.options[i];
      });

      this.renderOptions();
      this.update();
      this.setError('');

      this.root.classList.remove('hidden');
      this.root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('upsell-lock');
      requestAnimationFrame(() => this.root.classList.add('is-open'));
      if (!this.isOpen) history.pushState({ upsellPopup: true }, '');
      this.isOpen = true;
      setTimeout(() => this.root.querySelector('.upsell-popup__close').focus({ preventScroll: true }), 50);
    }

    close({ fromHistory = false } = {}) {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('upsell-lock');
      setTimeout(() => this.root.classList.add('hidden'), 300);
      if (!fromHistory && history.state && history.state.upsellPopup) history.back();
      if (this.trigger && this.trigger.focus) this.trigger.focus({ preventScroll: true });
    }

    /* ---------- Options ---------- */
    renderOptions() {
      this.options.innerHTML = '';
      this.optionsData.forEach((option, index) => {
        const group = document.createElement('div');
        group.className = 'upsell-popup__group';
        group.dataset.index = index;

        const label = document.createElement('p');
        label.className = 'upsell-popup__label';
        label.innerHTML = `<span>${isColour(option.name) ? 'Colour' : option.name}</span><span class="upsell-popup__label-value"></span>`;
        group.appendChild(label);

        const list = document.createElement('div');
        list.className = isColour(option.name) ? 'upsell-popup__swatches' : 'upsell-popup__pills';

        if (isColour(option.name) && this.swatchesHtml) {
          list.innerHTML = new DOMParser().parseFromString(this.swatchesHtml, 'text/html').body.innerHTML;
          list.querySelectorAll('.swatch-item').forEach((el) => {
            el.setAttribute('role', 'button');
            el.setAttribute('tabindex', '0');
            el.setAttribute('aria-label', el.dataset.value);
          });
        } else {
          option.values.forEach((value) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'upsell-popup__pill';
            b.dataset.value = value;
            b.textContent = value;
            list.appendChild(b);
          });
        }

        list.addEventListener('click', (e) => {
          const choice = e.target.closest('[data-value]');
          if (!choice || choice.classList.contains('is-unavailable-colour')) return;
          this.select(index, choice.dataset.value);
        });
        list.addEventListener('keydown', (e) => {
          const choice = e.target.closest('.swatch-item');
          if (choice && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            this.select(index, choice.dataset.value);
          }
        });

        group.appendChild(list);
        this.options.appendChild(group);
      });
    }

    select(index, value) {
      this.selected[index] = value;
      // Changing colour: keep the size if it is in stock in that colour, else move to the first in-stock size
      const current = this.findVariant();
      if (index === this.colourIndex && (!current || !current.available)) {
        const alt = this.variants.find((v) => v.options[index] === value && v.available) ||
          this.variants.find((v) => v.options[index] === value);
        if (alt) this.selected = [...alt.options];
      }
      this.setError('');
      this.update();
    }

    findVariant() {
      return this.variants.find((v) => v.options.every((opt, i) => opt === this.selected[i]));
    }

    update() {
      const variant = this.findVariant();
      this.variant = variant;

      this.options.querySelectorAll('.upsell-popup__group').forEach((group) => {
        const i = Number(group.dataset.index);
        group.querySelector('.upsell-popup__label-value').textContent = this.selected[i] || '';
        group.querySelectorAll('[data-value]').forEach((el) => {
          const value = el.dataset.value;
          el.classList.toggle('active', value === this.selected[i]);
          el.setAttribute('aria-pressed', String(value === this.selected[i]));
          // Available if some variant with this value (and the other current selections) is in stock
          const test = [...this.selected];
          test[i] = value;
          const available = i === this.colourIndex
            ? this.variants.some((v) => v.options[i] === value && v.available)
            : this.variants.some((v) => v.available && v.options.every((opt, j) => opt === test[j]));
          el.classList.toggle('is-unavailable', !available);
        });
      });

      const shown = variant || this.variants.find((v) => this.colourIndex > -1 && v.options[this.colourIndex] === this.selected[this.colourIndex]);
      this.price.textContent = shown ? money(shown.price) : money(this.trigger.dataset.price);
      this.renderGallery();

      const soldOut = !variant || !variant.available;
      this.addBtn.disabled = soldOut;
      this.addLabel.textContent = !variant ? 'Unavailable' : soldOut ? 'Sold out' : 'Add to cart';
    }

    /* ---------- Gallery: only images sharing the selected colour's alt text ---------- */
    renderGallery() {
      const colourValue = this.colourIndex > -1 ? this.selected[this.colourIndex] : null;
      const lead = this.variant ||
        this.variants.find((v) => colourValue != null && v.options[this.colourIndex] === colourValue) ||
        this.variants[0];
      const alt = lead && lead.image_alt;

      let set = alt ? this.images.filter((img) => img.alt === alt) : [];
      if (!set.length && lead && lead.image) set = [{ src: lead.image, alt: alt || '' }];
      if (!set.length) set = this.images.slice(0, 1);

      // Lead with the variant's own featured image
      if (lead && lead.image) {
        const key = imageKey(lead.image);
        set.sort((a, b) => (imageKey(b.src) === key) - (imageKey(a.src) === key));
      }

      const signature = set.map((i) => i.src).join('|');
      if (signature === this.gallerySignature) return;
      this.gallerySignature = signature;

      this.setMain(set[0]);
      this.thumbs.innerHTML = '';
      this.thumbs.hidden = set.length < 2;
      set.forEach((img, i) => {
        const t = document.createElement('button');
        t.type = 'button';
        t.className = 'upsell-popup__thumb' + (i === 0 ? ' active' : '');
        t.setAttribute('aria-label', `View image ${i + 1}`);
        t.innerHTML = `<img src="${img.src}" alt="" loading="lazy">`;
        t.addEventListener('click', () => {
          this.thumbs.querySelectorAll('.upsell-popup__thumb').forEach((n) => n.classList.toggle('active', n === t));
          this.setMain(img);
        });
        this.thumbs.appendChild(t);
      });
    }

    setMain(img) {
      if (!img) return;
      this.mainImage.classList.remove('is-loaded');
      this.mainImage.onload = () => this.mainImage.classList.add('is-loaded');
      this.mainImage.src = img.src;
      this.mainImage.alt = img.alt || this.title.textContent;
      if (this.mainImage.complete) this.mainImage.classList.add('is-loaded');
    }

    setError(msg) {
      this.error.textContent = msg;
      this.error.hidden = !msg;
    }

    /* ---------- Cart ---------- */
    async addToCart() {
      const variant = this.variant;
      if (!variant || !variant.available) return;
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];

      this.addBtn.disabled = true;
      this.addBtn.classList.add('is-loading');
      try {
        const res = await fetch(`${(window.routes && routes.cart_add_url) || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1, sections, sections_url: window.location.pathname }),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');

        this.close();
        if (drawer && drawer.renderContents && data.sections) {
          // renderContents clears the empty state, refreshes the cart bubble and opens the drawer
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.href = (window.routes && routes.cart_url) || '/cart';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-popup', productVariantId: variant.id, cartData: data });
        }
      } catch (err) {
        this.setError(err.message);
      } finally {
        this.addBtn.classList.remove('is-loading');
        this.addBtn.disabled = !this.variant || !this.variant.available;
      }
    }
  }

  const init = () => {
    const root = document.getElementById('UpsellPopup');
    if (!root) return;
    window.upsellPopup = new UpsellPopup(root);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();

  // One delegated trigger for every .upsell-add-btn (product cards, cart upsells, PDP sticky bar)
  document.addEventListener('click', (e) => {
    const button = e.target.closest('.upsell-add-btn');
    if (!button || !window.upsellPopup) return;
    e.preventDefault();
    e.stopPropagation();
    window.upsellPopup.open(button);
  });
})();
